import axiosConfig from "./axiosConfig";
import { PromptAddendumModel } from "./getLandlordResearchPrompt";
import { LandlordResearchResponse } from "./postVoaResearchLandlord";

export interface LandlordPromptTestRequest {
  // The DRAFT prompt to test - not saved. Passed as an addendum (preamble +
  // rules) and compiled by the BE via the same render used on save, so the
  // tested prompt is exactly what saving this draft would run. The BE appends
  // the fixed data-residency guardrail before running.
  addendum: PromptAddendumModel;
  // A real subject row to run against for its address/context. Nothing is
  // persisted onto it (test runs are read-only for the subject).
  subjectRef: string;
  subjectKind?: "voa" | "lead";
}

// Kick off a test research run against a draft prompt as a long-running
// operation (research can take minutes). Returns {operationKey, siteId}
// immediately; the FE polls useOperation(...) and reads the candidates +
// trace ref out of the operation result. Persists nothing onto the subject.
const postLandlordResearchPromptTest = async (
  authToken: string,
  body: LandlordPromptTestRequest
): Promise<LandlordResearchResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/ai-prompt/test`,
    { ...body, task: "landlord_research" },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postLandlordResearchPromptTest;
